import { lazy } from "react";

const RoutesPaths = [
	{
		path: "/login",
		component: lazy(() => import("../../Components/SignIn/Login")),
		meta: {
			authRoute: false,
			roles: ["all"],
		},
	},
	{
		path: "/",
		component: lazy(() => import("../../Components/Dashboard/Dashboard")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/dashboard",
		component: lazy(() => import("../../Components/Dashboard/Dashboard")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/agent/dashboard",
		component: lazy(() => import("../../Components/Agent/Dashboard/AgentDashboard")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["agent_management"],
		},
	},
	{
		path: "/agent/list",
		component: lazy(() => import("../../Components/Agent/AgentList/AgentList")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["agent_management"],
		},
	},
	{
		path: "/agent/create",
		component: lazy(() => import("../../Components/Agent/AgentForm/AgentCreate")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["agent_management"],
		},
	},
	{
		path: "/agent/edit/:id",
		component: lazy(() => import("../../Components/Agent/AgentForm/AgentEdit")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["agent_management"],
		},
	},
	{
		path: "/agent/view/:id",
		component: lazy(() => import("../../Components/Agent/AgentDetail/AgentDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["agent_management"],
		},
	},
	{
		path: "/tourist-places",
		component: lazy(() =>
			import("../../Components/TouristPlaces/TouristPlaces")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/optional-attractions",
		component: lazy(() =>
			import("../../Components/TouristPlaces/OptionalAttractionsList")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/create-optional-attraction",
		component: lazy(() =>
			import("../../Components/TouristPlaces/OptionalAttractionsForm")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/update-optional-attraction/:ID",
		component: lazy(() =>
			import("../../Components/TouristPlaces/OptionalAttractionsForm")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/create-place",
		component: lazy(() => import("../../Components/TouristPlaces/CreatePlace")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/update-place/:id",
		component: lazy(() => import("../../Components/TouristPlaces/UpdatePlace")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/place/images/:id",
		component: lazy(() =>
			import("../../Components/TouristPlaces/Gallery/Images")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/place/videos/:id",
		component: lazy(() =>
			import("../../Components/TouristPlaces/Gallery/Videos")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/place/reels/:id",
		component: lazy(() =>
			import("../../Components/TouristPlaces/Gallery/Reels")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/off-place/:itemId",
		component: lazy(() => import("../../Components/TouristPlaces/PlaceOff")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/place/on",
		component: lazy(() => import("../../Components/TouristPlaces/BookingOn")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/place/off",
		component: lazy(() => import("../../Components/TouristPlaces/BookingOff")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/package",
		component: lazy(() => import("../../Components/Package/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/create-package",
		component: lazy(() => import("../../Components/Package/CreatePackage")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/update-package/:id",
		component: lazy(() => import("../../Components/Package/UpdatePackage")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/package/images/:id",
		component: lazy(() => import("../../Components/Package/Gallery/Images")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/package/videos/:id",
		component: lazy(() => import("../../Components/Package/Gallery/Videos")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/package/reels/:id",
		component: lazy(() => import("../../Components/Package/Gallery/Reels")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/package/category",
		component: lazy(() => import("../../Components/Package/Category/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/create-category",
		component: lazy(() =>
			import("../../Components/Package/Category/CreateCategory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/update-category/:id",
		component: lazy(() =>
			import("../../Components/Package/Category/UpdateCategory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["add_item"],
		},
	},
	{
		path: "/attraction-booking/:slug",
		component: lazy(() => import("../../Components/Booking/AttractionBooking")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/package-booking/:slug",
		component: lazy(() => import("../../Components/Booking/PackageBooking")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_package_booking"],
		},
	},
	{
		path: "/booking/detail/:id",
		component: lazy(() => import("../../Components/Booking/BookingDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/confirm/:id",
		component: lazy(() => import("../../Components/Booking/BookingDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/sou-ticket/:id",
		component: lazy(() => import("../../Components/Booking/BookingDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/specific-cancellation/:id",
		component: lazy(() => import("../../Components/Booking/BookingDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/booking-cancel/:id",
		component: lazy(() => import("../../Components/Booking/BookingDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/payment/:id",
		component: lazy(() => import("../../Components/Booking/BookingDetail")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/setting/site-settings",
		component: lazy(() => import("../../Components/Settings/siteSetting")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/service-charge",
		component: lazy(() =>
			import("../../Components/Settings/ServiceChargeSetting")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/home-page-banner",
		component: lazy(() =>
			import("../../Components/Settings/homeBannerSetting")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/home-page-places",
		component: lazy(() => import("../../Components/Settings/homePlaceSetting")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/home-page-packages",
		component: lazy(() => import("../../Components/Settings/siteSetting")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/sou-phone-number",
		component: lazy(() => import("../../Components/Settings/SouPhoneNumber")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/home-note",
		component: lazy(() => import("../../Components/Settings/homePageNote")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/place-key",
		component: lazy(() => import("../../Components/Settings/placeKeys")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/faqs",
		component: lazy(() => import("../../Components/Settings/faqs")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/hotel",
		component: lazy(() => import("../../Components/Settings/HotelSettings")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/setting/hotel-admin",
		component: lazy(() => import("../../Components/Settings/HotelAdmin")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/cancel_booking",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/BookingList")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["cancel_booking", "cancel_confirm", "specific_cancel_booking"],
		},
	},
	{
		path: "/sou-booking-cancel/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/SOUCancel")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["cancel_booking"],
		},
	},
	{
		path: "/booking-cancel-confirm/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/CancelConfirm")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["cancel_booking"],
		},
	},
	{
		path: "/booking-specific-cancel-confirm/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/SpecificCancelConfirm")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["specific_cancel_booking"],
		},
	},
	{
		path: "/refund_booking",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/BookingList")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["refund_booking"],
		},
	},
	{
		path: "/booking-refund/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/BookingRefund")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["refund_booking"],
		},
	},
	{
		path: "/booking-refunded/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/RefundedBookingView")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["refund_booking"],
		},
	},
	{
		path: "/booking-specific-refund/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/SpecificRefund")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["refund_booking"],
		},
	},
	{
		path: "/booking-specific-refunded/:id",
		component: lazy(() =>
			import(
				"../../Components/Booking/BookingActions/SpecificRefundedBookingView"
			)
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["refund_booking"],
		},
	},
	{
		path: "/team",
		component: lazy(() => import("../../Components/Team/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["team_member"],
		},
	},
	{
		path: "/create-member",
		component: lazy(() => import("../../Components/Team/CreateMember")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["team_member"],
		},
	},
	{
		path: "/update-member/:id",
		component: lazy(() => import("../../Components/Team/UpdateMember")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["team_member"],
		},
	},
	{
		path: "/team/attendance",
		component: lazy(() => import("../../Components/Team/Attendance")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["emp_attendance"],
		},
	},
	{
		path: "/team/summary-report",
		component: lazy(() => import("../../Components/Team/SalaryReport")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["emp_attendance"],
		},
	},
	{
		path: "/team/bank-access",
		component: lazy(() => import("../../Components/Team/BankAccess")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["bank_access"],
		},
	},
	{
		path: "/team/report",
		component: lazy(() => import("../../Components/Team/Report/Report")),
		meta: {
			authRoute: true,
			roles: [1],
		},
	},
	{
		path: "/team/report/sales",
		component: lazy(() => import("../../Components/Team/Report/SalesReport")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/team/number-access",
		component: lazy(() => import("../../Components/Team/NumberAccess")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["number_access"],
		},
	},
	{
		path: "/accounting/bank-account",
		component: lazy(() => import("../../Components/Accounting/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/tally/main-group",
		component: lazy(() => import("../../Components/Accounting/TallyMainGroup")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["account_tally"],
		},
	},
	{
		path: "/accounting/tally/sub-group",
		component: lazy(() => import("../../Components/Accounting/TallySubGroup")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["account_tally"],
		},
	},
	{
		path: "/accounting/tally/ledger",
		component: lazy(() => import("../../Components/Accounting/TallyLedger")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["account_tally"],
		},
	},
	{
		path: "/accounting/tally/balance-sheet",
		component: lazy(() => import("../../Components/Accounting/BalanceSheet")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["account_tally"],
		},
	},
	{
		path: "/accounting/tally/profit-loss",
		component: lazy(() => import("../../Components/Accounting/ProfitAndLoss")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["account_tally"],
		},
	},
	{
		path: "/accounting/auto-entry-settings",
		component: lazy(() =>
			import("../../Components/Accounting/AutoAccountEntrySettings")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/credit-card",
		component: lazy(() =>
			import("../../Components/Accounting/CreditCard/List")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/credit-type",
		component: lazy(() =>
			import("../../Components/Accounting/CreditType/List")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/debit-type",
		component: lazy(() =>
			import("../../Components/Accounting/DebitType/List")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/create-bank-account",
		component: lazy(() =>
			import("../../Components/Accounting/CreateBankAccount")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/update-bank-account/:id",
		component: lazy(() =>
			import("../../Components/Accounting/UpdateBankAccount")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/create-credit-card",
		component: lazy(() =>
			import("../../Components/Accounting/CreditCard/CreateCreditCard")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/update-credit-card/:id",
		component: lazy(() =>
			import("../../Components/Accounting/CreditCard/UpdateCreditCard")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/create-credit-type",
		component: lazy(() =>
			import("../../Components/Accounting/CreditType/CreateCreditType")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/update-credit-type/:id",
		component: lazy(() =>
			import("../../Components/Accounting/CreditType/UpdateCreditType")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/create-debit-type",
		component: lazy(() =>
			import("../../Components/Accounting/DebitType/CreateDebitType")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/update-debit-type/:id",
		component: lazy(() =>
			import("../../Components/Accounting/DebitType/UpdateDebitType")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/staff-debit-note",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/StaffDebitNote")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/staff-credit-note",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/StaffCreditNote")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/payment",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/Payment")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/journal",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/JournalVoucher")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/credit-type",
		component: lazy(() =>
			import("../../Components/Accounting/CreditType/List")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/debit-type",
		component: lazy(() =>
			import("../../Components/Accounting/DebitType/List")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/receipt",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/Receipt")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/bank-transfer",
		component: lazy(() =>
			import("../../Components/Accounting/BankTransfer/BankTransfer")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/sales",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/Sales")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/purchase",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/Purchase")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/debit-note",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/DebitNote")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/credit-note",
		component: lazy(() =>
			import("../../Components/Accounting/CR_DR/CreditNote")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["accounting"],
		},
	},
	{
		path: "/accounting/reports/pending-settlement",
		component: lazy(() =>
			import("../../Components/Accounting/Reports/PendingSettlement")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["daily_settlements"],
		},
	},
	{
		path: "/accounting/reports/settlement-history",
		component: lazy(() =>
			import("../../Components/Accounting/Reports/SettlementHistory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["daily_settlements"],
		},
	},
	{
		path: "/accounting/reports/settlement",
		component: lazy(() =>
			import("../../Components/Accounting/Reports/Settlement")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["daily_settlements"],
		},
	},
	{
		path: "/reports/sales",
		component: lazy(() => import("../../Components/Accounting/Reports/Sales")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["report"],
		},
	},
	{
		path: "/reports/offline-sales",
		component: lazy(() => import("../../Components/Accounting/Reports/Sales")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["report"],
		},
	},
	{
		path: "/reports/purchase",
		component: lazy(() =>
			import("../../Components/Accounting/Reports/Purchase")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["report"],
		},
	},
	{
		path: "/reports/commission",
		component: lazy(() =>
			import("../../Components/Accounting/Reports/Commission")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["report"],
		},
	},
	{
		path: "/reports/cancel",
		component: lazy(() => import("../../Components/Accounting/Reports/Cancel")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["report"],
		},
	},
	{
		path: "/reports/gst",
		component: lazy(() => import("../../Components/Accounting/Reports/GST")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["report"],
		},
	},
	{
		path: "/reports/attraction",
		component: lazy(() =>
			import("../../Components/Booking/Report/AttractionReport")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["booking_history"],
		},
	},
	{
		path: "/booking-for-review",
		component: lazy(() =>
			import("../../Components/Booking/Report/BookingForReview")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["booking_history"],
		},
	},
	{
		path: "/payment-history",
		component: lazy(() =>
			import("../../Components/PaymentHistory/PaymentHistory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["payment_report"],
		},
	},
	{
		path: "/daily-ledger-report",
		component: lazy(() =>
			import("../../Components/PaymentHistory/DailyLedgerReport")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["payment_report"],
		},
	},
	{
		path: "/assign-account/bank",
		component: lazy(() => import("../../Components/AssignAccount/Bank")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/assign-account/credit-card",
		component: lazy(() => import("../../Components/AssignAccount/CreditCard")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/bank-account/access",
		component: lazy(() => import("../../Components/Team/BankReport/BankAccess")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/bank-account/report",
		component: lazy(() => import("../../Components/Team/BankReport/BankDetailReport")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/sou-otp-number",
		component: lazy(() => import("../../Components/OTPNumber/OTPNumber")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/upcoming_booking",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/BookingList")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["upcoming_orders"],
		},
	},
	{
		path: "/booking/upcoming-detail/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/BookingDetail")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["upcoming_orders"],
		},
	},
	{
		path: "/quotations/:slug",
		component: lazy(() => import("../../Components/Quotation/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["create_order"],
		},
	},
	{
		path: "/quotation/create",
		component: lazy(() => import("../../Components/Quotation/CreateQuotation")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["create_order"],
		},
	},
	{
		path: "/quotation/add-visitors/:id",
		component: lazy(() => import("../../Components/Quotation/AddVisitor")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["create_order"],
		},
	},
	{
		path: "/quotation/action/:id",
		component: lazy(() => import("../../Components/Quotation/QuotationAction")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["create_order"],
		},
	},
	{
		path: "/quotation/edit/:id",
		component: lazy(() => import("../../Components/Quotation/UpdateQuotation")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["create_order"],
		},
	},
	{
		path: "/attraction-booking-history/:slug",
		component: lazy(() =>
			import("../../Components/Booking/AttractionBookingHistory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["booking_history"],
		},
	},
	{
		path: "/package-booking-history/:slug",
		component: lazy(() =>
			import("../../Components/Booking/PackageBookingHistory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["booking_history"],
		},
	},
	{
		path: "/other-sou-booking",
		component: lazy(() => import("../../Components/Booking/OtherSOUBooking")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/profile",
		component: lazy(() => import("../../Components/Profile/Profile")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/enquiry/pending",
		component: lazy(() => import("../../Components/Enquiry/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/enquiry/confirm",
		component: lazy(() => import("../../Components/Enquiry/Confirm")),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/hotel/amenities",
		component: lazy(() => import("../../Components/Hotel/amenities/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_amenities"],
		},
	},
	{
		path: "/hotel/amenities/create",
		component: lazy(() => import("../../Components/Hotel/amenities/Create")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_amenities"],
		},
	},
	{
		path: "/hotel/amenities/:id",
		component: lazy(() => import("../../Components/Hotel/amenities/Update")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_amenities"],
		},
	},
	{
		path: "/hotel/facilities",
		component: lazy(() => import("../../Components/Hotel/facilities/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_facilities"],
		},
	},
	{
		path: "/hotel/facilities/create",
		component: lazy(() => import("../../Components/Hotel/facilities/Create")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_facilities"],
		},
	},
	{
		path: "/hotel/facilities/:id",
		component: lazy(() => import("../../Components/Hotel/facilities/Update")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_facilities"],
		},
	},
	{
		path: "/hotel/room-category",
		component: lazy(() => import("../../Components/Hotel/room-category/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_room_category"],
		},
	},
	{
		path: "/hotel/room-category/create",
		component: lazy(() =>
			import("../../Components/Hotel/room-category/Create")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_room_category"],
		},
	},
	{
		path: "/hotel/room-category/:id",
		component: lazy(() =>
			import("../../Components/Hotel/room-category/Update")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_room_category"],
		},
	},
	{
		path: "/hotel",
		component: lazy(() => import("../../Components/Hotel/HotelData/HotelList")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_list"],
		},
	},
	{
		path: "/hotel/dashboard",
		component: lazy(() => import("../../Components/Hotel/Dashboard/Dashboard")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_dashboard"],
		},
	},
	{
		path: "/hotel/booking",
		component: lazy(() => import("../../Components/Hotel/Booking/BookingList")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_all_booking"],
		},
	},
	{
		path: "/hotel/booking-history",
		component: lazy(() =>
			import("../../Components/Hotel/Booking/BookingHistory")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_all_booking"],
		},
	},
	{
		path: "/hotel/booking/refund-pending",
		component: lazy(() =>
			import("../../Components/Hotel/Booking/Refund/RefundPending")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_refund"],
		},
	},
	{
		path: "/hotel/booking/refund-pending/:bookingId",
		component: lazy(() =>
			import("../../Components/Hotel/Booking/Refund/OneRefund")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_refund"],
		},
	},
	{
		path: "/hotel/booking/exchange",
		component: lazy(() =>
			import("../../Components/Hotel/Booking/ExchangeBooking")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_booking_exchange"],
		},
	},
	{
		path: "/hotel/booking/:bookingId",
		component: lazy(() =>
			import("../../Components/Hotel/Booking/OneBooking/OneBooking")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_all_booking"],
		},
	},
	{
		path: "/hotel/:id",
		component: lazy(() => import("../../Components/Hotel/HotelData/layout")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_list"],
		},
		children: [
			{
				path: "",
				component: lazy(() =>
					import("../../Components/Hotel/HotelData/HotelProfile")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_list"],
				},
			},
			{
				path: "hotel-property",
				component: lazy(() =>
					import("../../Components/Hotel/HotelData/HotelProperty")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_list"],
				},
			},
			{
				path: "property-rules",
				component: lazy(() =>
					import("../../Components/Hotel/HotelData/PropertiesRules")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_list"],
				},
			},
			{
				path: "rooms",
				component: lazy(() =>
					import("../../Components/Hotel/HotelData/rooms/List")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_list"],
				},
			},
			{
				path: "rooms/create",
				component: lazy(() =>
					import("../../Components/Hotel/HotelData/rooms/Create")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_list"],
				},
			},
			{
				path: "rooms/:roomId",
				component: lazy(() =>
					import("../../Components/Hotel/HotelData/rooms/Update")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_list"],
				},
			},
		],
	},
	{
		path: "/hotel/inventory",
		component: lazy(() => import("../../Components/Hotel/inventory/Inventory")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_inventory"],
		},
	},
	{
		path: "/hotel/contact",
		component: lazy(() =>
			import("../../Components/Hotel/HotelContact/HotelContact")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_contact"],
		},
	},
	{
		path: "/hotel/contact/create",
		component: lazy(() =>
			import("../../Components/Hotel/HotelContact/CreateContactDetails")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_contact"],
		},
	},
	{
		path: "/hotel/settlement",
		component: lazy(() =>
			import("../../Components/Hotel/PaymentHistory/layout")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_settlement_summary"],
		},
		children: [
			{
				path: ":id",
				component: lazy(() =>
					import("../../Components/Hotel/PaymentHistory/SettlementData")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_settlement_summary"],
				},
			},
			{
				path: "summary",
				component: lazy(() =>
					import("../../Components/Hotel/PaymentHistory/SettlementSummary")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_settlement_summary"],
				},
			},
			{
				path: "generated",
				component: lazy(() =>
					import("../../Components/Hotel/PaymentHistory/SettlementGenerated")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_settlement_summary"],
				},
			},
			{
				path: "completed",
				component: lazy(() =>
					import("../../Components/Hotel/PaymentHistory/SettlementCompleted")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_settlement_summary"],
				},
			},
		],
	},
	{
		path: "/hotel/report",
		component: lazy(() => import("../../Components/Hotel/report/layout")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["hotel_report"],
		},
		children: [
			{
				path: "sales-report",
				component: lazy(() =>
					import("../../Components/Hotel/report/HotelSales")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
			{
				path: "today-check-in",
				component: lazy(() =>
					import("../../Components/Hotel/report/TodayCheckIn")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
			{
				path: "today-check-out",
				component: lazy(() =>
					import("../../Components/Hotel/report/TodayCheckOut")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
			{
				path: "settlement-pending",
				component: lazy(() =>
					import("../../Components/Hotel/report/SettlementPending")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
			{
				path: "settlement-completed",
				component: lazy(() =>
					import("../../Components/Hotel/report/SettlementCompleted")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
			{
				path: "cancel-report",
				component: lazy(() =>
					import("../../Components/Hotel/report/HotelCancel")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
			{
				path: "refund-report",
				component: lazy(() =>
					import("../../Components/Hotel/report/HotelRefund")
				),
				meta: {
					authRoute: true,
					roles: [1, 2],
					accessKeys: ["hotel_report"],
				},
			},
		],
	},
	{
		path: "/available-tickets",
		component: lazy(() =>
			import("../../Components/TouristPlaces/AvailableTickets")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
		},
	},
	{
		path: "/rikshaw/:slug",
		component: lazy(() =>
			import("../../Components/Booking/ErikshawBookingList")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/e-rikshaw/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/ErikshawBookingDetail")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/booking/e-rikshaw-confirm/:id",
		component: lazy(() =>
			import("../../Components/Booking/BookingActions/ErikshawBookingConfirm")
		),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sou_attraction_booking"],
		},
	},
	{
		path: "/testimonials",
		component: lazy(() => import("../../Components/Testimonial/List")),
		meta: {
			authRoute: true,
			roles: [1],
			accessKeys: ["testimonials"],
		},
	},
	{
		path: "/sitemap/list",
		component: lazy(() => import("../../Components/Sitemap/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["sitemap"],
		},
	},
	{
		path: "/blog/category",
		component: lazy(() => import("../../Components/Blog/Category/CategoryList")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},
	{
		path: "/create-blog-category",
		component: lazy(() => import("../../Components/Blog/Category/CreateCategory")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},
	{
		path: "/update-blog-category/:id",
		component: lazy(() => import("../../Components/Blog/Category/UpdateCategory")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},
	{
		path: "/blog/list",
		component: lazy(() => import("../../Components/Blog/Blog/BlogList")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},
	{
		path: "/create-blog",
		component: lazy(() => import("../../Components/Blog/Blog/CreateBlog")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},
	{
		path: "/update-blog/:id",
		component: lazy(() => import("../../Components/Blog/Blog/UpdateBlog")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},
	{
		path: "/blog-comments/:ID",
		component: lazy(() => import("../../Components/Blog/Comments/List")),
		meta: {
			authRoute: true,
			roles: [1, 2],
			accessKeys: ["blog_management"],
		},
	},

	{
		path: "/security/devices",
		component: lazy(() => import("../../Components/Security/TrustedDevices")),
		meta: {
			authRoute: true,
			roles: [1],
		},
	},
	{
		path: "/security/active-staff",
		component: lazy(() => import("../../Components/Security/ActiveStaffSessions")),
		meta: {
			authRoute: true,
			roles: [1],
		},
	},
	{
		path: "/security/login-logs",
		component: lazy(() => import("../../Components/Security/LoginLogs")),
		meta: {
			authRoute: true,
			roles: [1],
		},
	},
];

export default RoutesPaths;

